<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-pencil" class="mr-2" />
        Update Category
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.value"
                label="Category Name"
                variant="outlined"
                :rules="formRules.value"
                placeholder="Enter category name"
                :disabled="isLoading"
                autofocus
                :maxlength="255"
                counter
              />
            </VCol>
            <VCol cols="12" v-if="type === 'Main Category'">
              <VTextarea
                label="Description"
                v-model="form.description"
                variant="outlined"
                prepend-inner-icon="mdi-text"
                :maxlength="255"
              ></VTextarea>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Update
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import requestsService from '@/services/requests-service/requests.service';
// Text
import { successEditCategoryText, errorEditCategoryText } from '@/text/snackbarsText';
export default {
  name: 'EditCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object
    },
    type: {
      type: String
    },
    requestId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved', 'close'],

  watch: {
    category: {
      handler(newData) {
        this.form.value = newData.value;
        this.form.description = newData.description;
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      isLoading: false,
      form: {
        value: this.category.value,
        description: this.category.description
      },
      formValid: false,
      formRules: {
        value: [(v) => !!v || 'Category Name required']
      }
    };
  },

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const categoryData = {
            value: this.form.value,
            categoryId: this.category.categoryId,
            type: this.type,
            requestId: this.requestId,
            description: this.form.description
          };
          await requestsService.updateCategory(categoryData);
          this.showSnackbar({ text: successEditCategoryText, color: 'green' });
          this.handleSuccess(this.category.categoryId, this.form.value, this.form.description);
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorEditCategoryText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },

    handleSuccess(categoryId, newValue, description) {
      this.$emit('saved', { categoryId: categoryId, newValue: newValue, description: description });
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: ''
      };
    }
  }
};
</script>
